import React from 'react';
import PropTypes from 'prop-types';
import styles from './RiskStatusBar.css';

const TONES = {
    danger: { color: 'var(--error-light-color)', barColor: 'rgba(255, 0, 0, 0.4)' },
    success: { color: 'var(--success-dark-color)', barColor: 'var(--success-dark-color)' }
};

function RiskStatusBar({ label, tone = 'danger' }) {
    const { color, barColor } = TONES[tone];

    return (
        <div className={styles.root}>
            <p className={styles.label} style={{ color }}>{label}</p>
            <div className={styles.bar} style={{ backgroundColor: barColor }} />
        </div>
    );
}

RiskStatusBar.propTypes = {
    label: PropTypes.string.isRequired,
    tone: PropTypes.oneOf(['danger', 'success'])
};

export {
    RiskStatusBar
};
